import apiConfig from '../config/api_config'
import bus from '../libs/bus'
import customEvents from '../config/custom_events'
import storage from '../libs/storage'
import cacheKeys from '../config/cache_keys'
import {resourceServer} from '../config/common'
import DataValidator from '../libs/data_validator'

export default {
    data() {
        return {
            resourceServer,
            currentUser: {},
            isDataLoaded: false,
            currentActiveDrawer: '',
            currentActiveDialog: '',
        }
    },
    methods: {
        getComponent(componentName) {
            if (this.$refs && this.$refs[componentName]) {
                return this.$refs[componentName]
            }

            let component = this.$parent

            if (!component) {
                return null
            }

            for (let i = 1; i <= 9; i++) {
                if (component.$refs && component.$refs[componentName]) {
                    return component.$refs[componentName]
                }

                try {
                    component = component.$parent
                } catch (ex) {
                    component = null
                }

                if (!component) {
                    return null
                }
            }

            return null
        },
        searchFormSearch(...args) {
            const component = this.getComponent('searchForm')

            if (!component) {
                return
            }

            component.search.apply(component, [...args])
        },
        updateDataTable(arg) {
            const component = this.getComponent('dataTable')

            if (!component) {
                return
            }

            if (this.isArray(arg)) {
                component.update(arg)
                return
            }

            if (this.isApiResult(arg)) {
                component.update(arg.list)
                if (!this.isEmpty(arg.obj)) {
                    component.updateObj(arg.obj)
                }
                return
            }

        },
        // 分页信息
        paginationFormData(val) {
            if (this.isObject(val)) {
                let pagination = {
                    currentPage: val.current,
                    pageSize: val.size,
                    pageTotal: val.pages,
                    recordTotal: val.total
                }
                return pagination
            } else {
                return {}
            }
        },
        updateDataTableListItem(...args) {
            let fieldName = 'id'
            let fieldValue = null
            let newItem = null

            if (args.length == 2) {
                fieldValue = args[0]
                newItem = args[1]
            } else if (args.length > 2) {
                fieldName = args[0]
                fieldValue = args[1]
                newItem = args[2]
            }

            if (!fieldValue || !newItem) {
                return
            }

            if (this.isApiResult(newItem)) {
                newItem = newItem.obj
            }

            try {
                this.getComponent('dataTable').update(fieldName, fieldValue, newItem)
            } catch (ex) {
            }
        },
        dataTableRemoteSortItems() {
            const component = this.getComponent('dataTable')
            if (!component) {
                return
            }

            try {
                component.sort()
            } catch (ex) {
            }
        },
        resetDataTableList() {
            try {
                this.searchFormSearch({reset: true})
            } catch (ex) {
            }
        },
        showDrawer(...args) {
            let drawerName = ''
            const argumentList = []

            for (let arg of args) {
                if (this.isEvent(arg)) {
                    continue
                }

                if (drawerName != '') {
                    argumentList.push(arg)
                    continue
                }

                if (this.isNumber(arg)) {
                    drawerName = `drawer${arg}`
                    continue
                }

                if (this.isString(arg) && arg != '') {
                    drawerName = arg
                    continue
                }
            }

            if (drawerName == '') {
                return
            }

            const component = this.getComponent(drawerName)

            if (!component) {
                return
            }

            component.show.apply(component, argumentList)
        },
        getItemIdFromArguments(args) {
            for (let arg of args) {
                if (this.isNumber(arg) && arg > 0) {
                    return arg
                }
            }

            return 0
        },
        findItemInDataTableList(...args) {
            let fieldName = 'id'
            let fieldValue = null

            if (args.length == 1) {
                fieldValue = args[0]
            } else if (args.length > 1) {
                fieldName = args[0]
                fieldValue = args[1]
            }

            if (fieldValue == null) {
                return null
            }

            let item = null

            try {
                item = this.getComponent('dataTable').getList().find(it => {
                    return it[fieldName] == fieldValue
                })
            } catch (ex) {
                item = null
            }

            return !item ? null : Object.assign({}, item)
        },
        selfHideDrawer(...args) {
            this.clearValidationErrors()
            const n = args.length
            let afterClose = null

            if ('editor' in this && this.editor !== null) {
                this.editor.destroy()
                this.editor = null
            }

            if (n > 0 && this.isFunction(args[0])) {
                afterClose = args[0]
            } else if (n > 1 && this.isFunction(args[1])) {
                afterClose = args[1]
            }

            this.afterClose = afterClose
            this.collapse = true
        },
        selfOnDrawerVisibleChange(visible) {
            if (visible || !this.isFunction(this.afterClose)) {
                return
            }

            this.afterClose()
        },
        showLoading(tips) {
            if (!this.isString(tips) || tips == '') {
                tips = '加载中...'
            }

            bus.$emit(customEvents['loading.show'], {tips})
        },
        hideLoading() {
            bus.$emit(customEvents['loading.hide'])
        },
        alert(msg, ...args) {
            console.log("???11122")
            const defaultTitle = '提示信息'
            const defaultBtnText = '我知道了'
            let opts = {}
            let btnCallback = null
            const n = args.length

            if (n == 1) {
                if (this.isFunction(args[0])) {
                    btnCallback = args[0]
                } else {
                    opts = args[0]
                }
            } else if (n > 1) {
                opts = args[0]
                btnCallback = args[1]
            }
            console.log("来来")
            bus.$emit(customEvents['AlertDialog.show'], {
                msg,
                btnCallback,
                title: opts.title || defaultTitle,
                btnText: opts.btnText || defaultBtnText
            })
        },
        confirm(msg, ...args) {
            const defaultTitle = '确认信息'
            const defaultBtn1Text = '确 定'
            const defaultBtn2Text = '取 消'
            let opts = {}
            let btn1Callback = null
            let btn2Callback = null
            const n = args.length

            if (n == 1) {
                if (this.isFunction(args[0])) {
                    btn1Callback = args[0]
                } else {
                    opts = args[0]
                }
            } else if (n == 2) {
                if (this.isFunction(args[0])) {
                    btn1Callback = args[0]
                    btn2Callback = args[1]
                } else {
                    opts = args[0]
                    btn1Callback = args[1]
                }
            } else if (n > 2) {
                opts = args[0]
                btn1Callback = args[1]
                btn2Callback = args[2]
            }

            bus.$emit(customEvents['ConfirmDialog.show'], {
                msg,
                btn1Callback,
                btn2Callback,
                title: opts.title || defaultTitle,
                btn1Text: opts.btn1Text || defaultBtn1Text,
                btn2Text: opts.btn2Text || defaultBtn2Text
            })
        },
        hasException(apiResult, showErrorTips) {
            if (!this.isBoolean(showErrorTips)) {
                showErrorTips = true
            }

            if (!this.isObject(apiResult) || apiResult.errno == apiConfig.errno.apiCallException) {
                showErrorTips && this.showErrorTips('接口请求出错')
                return true
            }

            let errnos = [0, apiConfig.errno.dataValidationError]

            if (errnos.includes(apiResult.errno)) {
                return false
            }

            if (apiResult.errno == apiConfig.errno.tokenRefreshException) {
                return true
            }

            errnos = [
                apiConfig.errno.requireAccessToken,
                apiConfig.errno.invalidAccessToken,
                apiConfig.errno.accessTokenExpired
            ]

            if (errnos.includes(apiResult.errno)) {
                showErrorTips && this.showErrorTips('安全令牌已失效<br>请重新登录',
                    () => storage.sessionRemove(cacheKeys.jwt), this.$router.replace({name: 'login'})
                )
                return true
            }

            if (this.isString(apiResult.error) && !this.isEmpty(apiResult.error)) {
                showErrorTips && this.showErrorTips(apiResult.error)
                return true
            }

            return false
        },
        hasException2(apiResult, showErrorTips) {
            if (apiResult.errno != 0) {
                this.showErrorTips(apiResult.msg)
                return true
            }

            return false
        },
        showValidationErrors(p0, ...args) {
            if (!this.isObject(p0)) {
                p0 = {}
            }

            let validationErrors = p0

            if (this.isObject(p0.validationErrors)) {
                validationErrors = p0.validationErrors
            }

            if (this.isEmpty(validationErrors)) {
                return false
            }

            let errorTips = this.errorTips
            let showErrorTips = false
            let tips = '数据完整性验证错误<br>请检查各输入项是否按照要求填写'
            let msecs = 0

            for (let i = 0; i < args.length; i++) {
                if (this.isObject(args[i])) {
                    errorTips = args[i]
                } else if (this.isBoolean(args[i])) {
                    showErrorTips = args[i]
                } else if (this.isString(args[i])) {
                    tips = args[i]
                } else if (this.isNumber(args[i]) && args[i] > 0) {
                    msecs = args[i]
                }
            }

            if (!this.isObject(errorTips) || this.isEmpty(errorTips)) {
                return false
            }

            const errorKeys = Object.keys(errorTips)

            if (!showErrorTips) {
                for (let key in validationErrors) {
                    if (!errorKeys.includes(key)) {
                        continue
                    }

                    this.$set(errorTips, key, {show: true, msg: validationErrors[key]})
                }

                msecs > 0 && setTimeout(() => this.clearValidationErrors(errorTips), msecs)
                return true
            }

            this.showErrorTips(tips, () => {
                for (let key in validationErrors) {
                    if (!errorKeys.includes(key)) {
                        continue
                    }

                    this.$set(errorTips, key, {show: true, msg: validationErrors[key]})
                }

                msecs > 0 && setTimeout(() => this.clearValidationErrors(errorTips), msecs)
            })

            return true
        },
        clearValidationErrors(errorTips) {
            if (!this.isObject(errorTips)) {
                errorTips = this.isObject(this.errorTips) ? this.errorTips : {}
            }

            if (!this.isObject(errorTips) || this.isEmpty(errorTips)) {
                return
            }

            Object.keys(errorTips).forEach(key => {
                this.$set(errorTips, key, {show: false, msg: ''})
            })
        },
        showSuccessTips(...args) {
            let tips = '操作成功'
            let callback = null

            if (args.length == 1) {
                if (this.isFunction(args[0])) {
                    callback = args[0]
                } else {
                    tips = args[0]
                }
            } else if (args.length > 1) {
                tips = args[0]
                callback = args[1]
            }

            if (this.isFunction(callback)) {
                this.alert(tips, callback)
            } else {
                this.alert(tips)
            }
        },
        showErrorTips(...args) {
            let tips = '操作失败'
            let callback = null

            if (args.length == 1) {
                if (this.isFunction(args[0])) {
                    callback = args[0]
                } else {
                    tips = args[0]
                }
            } else if (args.length > 1) {
                tips = args[0]
                callback = args[1]
            }

            if (this.isFunction(callback)) {
                this.alert(tips, {title: '错误提示'}, callback)
            } else {
                this.alert(tips, {title: '错误提示'})
            }
        },
        returnUrl(val) {
            window.history.go(val)
        },
        apiGet(configKey, queryParams) {
            console.log("???111")
            return this.httpClient.get(configKey, queryParams)
        },
        apiPost(configKey, requestBody) {
            return this.httpClient.post(configKey, requestBody)
        },
        apiPostJson(configKey, requestBody) {
            return this.httpClient.postJson(configKey, requestBody)
        },
        apiPut(configKey, ...args) {
            let pathVariables = null
            let requestBody = null

            if (args.length == 1) {
                requestBody = args[0]
            } else if (args.length > 1) {
                pathVariables = args[0]
                requestBody = args[1]
            }

            return this.httpClient.put(configKey, pathVariables, requestBody)
        },
        apiPatch(configKey, ...args) {
            let pathVariables = null
            let requestBody = null

            if (args.length == 1) {
                requestBody = args[0]
            } else if (args.length > 1) {
                pathVariables = args[0]
                requestBody = args[1]
            }

            return this.httpClient.patch(configKey, pathVariables, requestBody)
        },
        apiDelete(configKey, pathVariables) {
            return this.httpClient.delete(configKey, pathVariables)
        },
        scrollToTop() {
            document.getElementById('mainContent').scrollTo(0, 0)
        },
        updateGlobalFrameSrc(url) {
            const el = document.getElementById('globalFrame')

            if (!el) {
                return
            }

            if (!this.isString(url) || this.isEmpty(url)) {
                el.src = 'about:blank';
                return
            }

            const rnd = this.rndString(12, 3)

            if (url.includes('?')) {
                url += `&rnd=${rnd}`
            } else {
                url += '?rnd=${rnd}'
            }

            el.src = url
        },
        downloadFile(apiResult, unlinkFile) {
            const {filepath, attachmentFileName} = apiResult.obj

            const sb = [
                apiConfig.prefix,
                apiConfig['file.download'].url,
                `?filepath=${encodeURIComponent(filepath)}`,
                `&attachmentFileName=${encodeURIComponent(attachmentFileName)}`
            ]

            if (unlinkFile) {
                sb.push('&unlinkFile=1')
            }

            this.updateGlobalFrameSrc(sb.join(''))
        },
        validate(data, validateRules, ...args) {
            const validator = new DataValidator()
            const validationErrors = validator.validate(data, validateRules)

            if (this.isEmpty(validationErrors)) {
                return true
            }
            this.showValidationErrors.apply(this, [validationErrors, ...args])
            return false
        },
        async getChinaRegions() {
            const items = storage.localGet('chinaRegions')

            if (this.isArray(items) && !this.isEmpty(items)) {
                return Promise.resolve(items)
            }

            let apiResult = null

            try {
                apiResult = await this.apiGet('ChinaRegions')
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return Promise.resolve([])
            }

            storage.localSet('chinaRegions', apiResult.list)
            return Promise.resolve(apiResult.list)
        },
        toLogin(){
            let father = this;
            father.$router.push('/login');
        },
        
        // 四舍五入
        toFixedString(num) {
            
            if (this.isEmpty(num)) {
                return ''
            }
        
            return Number(num).toFixed(2);
        },
        numFormat(num) {
            if(num >= 10000){
                num = Math.round(Math.round(num) / 1000) / 10  + 'w'
            } else if(num >= 1000){
                num = Math.round(Math.round(num) / 100) / 10  + 'k'
            } else if(num <= 10){
                num = num
            } else {
               num = Math.round(num)
            }
            return num
        },
    },
    created() {
        this.httpClient.setVm(this)
        this.resourceServer = resourceServer
        this.currentUser = storage.sessionGet(cacheKeys.currentUser) || {}
    },
    mounted() {
        this.updateGlobalFrameSrc('')

        if (!this.$route.meta.disableTabRefresh) {
            bus.$on(customEvents['tab.refresh'], msg => {
                if (msg.routeName != this.$route.name) {
                    return
                }

                this.isFunction(this.refreshTab) && this.refreshTab()
            })
        }
    },
    beforeDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/mixins/common.js